import { Controller } from "@hotwired/stimulus"
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default class extends Controller {
  static values = {
    markerColor: String,
    clusterColor: String
  };

  static targets = [
    "garageMap",
    "garagesJson"
  ];

  async connect() {
    this.observer = new IntersectionObserver(
      async (entries) => {
        if (entries[0].isIntersecting) {
          this.observer.disconnect();
          await this.getGarages();
          await this.initializeMap();
        }
      },
      { threshold: 0.1 }
    );

    this.observer.observe(this.element);
  }

  async getGarages() {
    if (this.hasGaragesJsonTarget) {
      this.garageData = JSON.parse(this.garagesJsonTarget.textContent);
    } else {
      console.error("No garages data source provided.");
    }
  }

  async initializeMap() {
    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
      "marker",
    );

    const map = new google.maps.Map(this.garageMapTarget, {
      center: { lat: 57.2315, lng: 17.1386},
      zoom: 3.3,
      mapId: "VPI_EUROPE_MAP"
    });

    const infoWindow = new google.maps.InfoWindow({
      content: "",
      disableAutoPan: false,
    });

    const markers = this.garageData.map(garage => {
      let attr = garage.attributes;
      let garage_link = '<a href="'+ attr['profile_url'] +'" target="_blank"><%= t(:profile_details) %></a>';
      const position = { lat: attr['latitude'], lng: attr['longitude'] };
      const content = "<h6>"+ attr['full_name'] +"</h6><p>"+ attr['address'] +"<br>"+ attr['postcode'] +" "+ attr['city'] +"<br>"+ attr['country'] +"</p><p>"+ garage_link +"</p>";

      const pin = new google.maps.marker.PinElement({
        background: this.markerColorValue, // main fill
        borderColor: "#ffffff",
        glyphColor: "#ffffff",
        scale: 1.1
      })

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position,
        content: pin,
      });

      // markers can only be keyboard focusable when they have click listeners
      // open info window when marker is clicked
      marker.addEventListener("click", () => {
        infoWindow.setContent(content);
        infoWindow.open(map, marker);
      });

      marker.addListener("mouseenter", () => {
        marker.zIndex = 100
        pin.scale = 1.15
      })

      marker.addListener("mouseleave", () => {
        marker.zIndex = 1
        pin.scale = 1.1
      })

      return marker;
    });

    // Add a marker clusterer to manage the markers.
    new MarkerClusterer({ map, markers, renderer: this.clusterRenderer() });
  }

  clusterRenderer() {
    return {
      render: ({ count, position }) => {
        const div = document.createElement("div")

        div.textContent = count
        div.style.cssText = `
          width: 48px;
          height: 48px;
          font-size: var(--step-0);
          background: ${this.clusterColorValue};
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          box-shadow: 0 2px 6px rgba(0,0,0,.4);
        `

        return new google.maps.marker.AdvancedMarkerElement({
          position,
          content: div
        })
      }
    }
  }
}
